import { Accordion } from '../../../../../../common/SharedComponents';
import { ILoanHistorySummaryTableRow } from '../common/constants/tables/interfaces/ILoanHistorySummaryTableRow';
import { IRentalTableRow } from '../common/constants/tables/interfaces/IRentalTableRow';
import { RentalTable } from './components/RentalTable';
interface RentalProps {
    rentalData: IRentalTableRow[] | undefined;
    onLoanSummaryClick: (loans: ILoanHistorySummaryTableRow[] | undefined) => void;
}
export const Rental: React.FC<RentalProps> = ({ onLoanSummaryClick, rentalData }) => {
    return (
        <>
            <Accordion
                title='Rental'
                isExpanded={true}
                id={`bll_rental`}
                isCollapsable={true}
            >
                <div
                    className='card'
                    style={{ width: '600px', border: '1px solid gray' }}
                >
                    <div className='card-section'>
                        <RentalTable
                            onLoanSummaryClick={onLoanSummaryClick}
                            rentalData={rentalData}
                        />
                    </div>
                </div>
            </Accordion>
        </>
    );
};
